// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qnns","input":"styles_input__1kH0j"};